import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGnubashComponent } from './simple-icons-gnubash.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGnubashComponent ],
    exports:      [ SimpleIconsGnubashComponent ],
    bootstrap:    []
})
export class SimpleIconsGnubashModule {}
